import { Link } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'
import { LocalizedLink } from '#app/utils/i18n.tsx'
import { cn } from '#app/utils/misc.tsx'

export function ProductLink({
	link,
	className,
	children,
	localized = true,
	reset = false,
}: {
	link: string
	localized?: boolean
	className?: string
	children?: React.ReactNode
	reset?: boolean
}) {
	if (!localized) {
		return (
			<Link
				to={link}
				className={cn(
					'group rounded-full border border-white bg-transparent text-white hover:bg-white/10',
					'z-10 flex items-center justify-center gap-sm',
					'transition-colors duration-150 ease-in-out',
					'aspect-square w-[200px] select-none sm:w-[300px] lg:w-[350px]',
					!reset &&
						'absolute bottom-[10%] left-1/2 -translate-x-1/2 md:left-auto md:right-[12%] md:translate-x-0',
					// "xl:w-[450px]",
					className,
				)}
			>
				<div className="flex flex-col items-start justify-start gap-sm text-sm uppercase tracking-[0.2em] sm:font-bold">
					<span>{children}</span>
					<Icon
						name="arrow-right"
						className="mr-auto h-11 w-11 transition-all duration-200 ease-in-out group-hover:ml-md"
					/>
				</div>
			</Link>
		)
	}

	return (
		<LocalizedLink
			to={link}
			className={cn(
				'group rounded-full border border-white bg-transparent text-white hover:bg-white/10',
				'z-10 flex items-center justify-center gap-sm',
				'transition-colors duration-150 ease-in-out',
				'aspect-square w-[200px] select-none sm:w-[300px] lg:w-[350px]',
				!reset &&
					'absolute bottom-[10%] left-1/2 -translate-x-1/2 md:left-auto md:right-[12%] md:translate-x-0',
				// "xl:w-[450px]",
				className,
			)}
		>
			<div className="flex flex-col items-start justify-start gap-sm text-sm uppercase tracking-[0.2em] sm:font-bold">
				<span>{children}</span>
				<Icon
					name="arrow-right"
					className="mr-auto size-8 transition-all duration-200 ease-in-out group-hover:ml-md md:size-11"
				/>
			</div>
		</LocalizedLink>
	)
}
